<template>
  <div>
    <!-- <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline" v-if="editedIndex > -1">Lab Test</span>
            <span class="headline" v-else>Add Lab Test</span>
          </v-card-title>
          <v-card-text>
            <v-autocomplete single-line v-on:change="updateLabTest"
            :value='editedItem.labTest'
            :items='labTests'
            return-object
            label='Lab Test'
          ></v-autocomplete>
          <v-layout row>
            <v-flex xs6>
              <v-text-field v-model="editedItem.value1" label="Value"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="editedItem.units1" label="Units"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-text-field v-model="editedItem.comment" label="Comment"></v-text-field>
          </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="close">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>LAB TESTS
            <v-spacer></v-spacer>
            <v-btn @click="addLabTestTapped" color='primary'>ADD LAB TEST</v-btn>
          </v-card-title>
          <v-data-table
              :headers='headers'
              :items='labs'
              item-key='id'
              hide-actions
              class="elevation-1"
              >
              <template slot="items" slot-scope="props">
                <tr>
                  <td><v-select
                    @change="updateLabTest(props.index, props.item)"
                    v-model="props.item.labTest"
                    :items='labTests'
                    class="subheading font-weight-bold"
                    return-object
                  ></v-select></td>
                  <td><input onClick="this.select();" size=15  v-model.number="props.item.value1"></td>
                  <td><input onClick="this.select();" size=15 v-model="props.item.units1"></td>
                  <td><input onClick="this.select();" size=50 v-model.number="props.item.comment"></td>
                  <td class="justify-end">
                    <v-icon
                      color="alert"
                      small
                      @click="deleteItem(props.index)"
                    >
                      delete
                    </v-icon>
                  </td>
                </tr>
              </template>
          </v-data-table>
          </v-card>
        </v-flex>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['wo'],
  data () {
    return {
      dialogFooter: false,
      dialog: false,
      editedItem: {},
      editedIndex: -1,
      labs: [],
      deletedLabs: [],
      headers: [
        { text: 'LAB TEST', value: 'labTest', sortable: false, width: '350px', fixed: true },
        { text: 'VALUE1', value: 'value1', sortable: false, width: '200px', fixed: true, align: 'center' },
        { text: 'UNITS1', value: 'units1', sortable: false, width: '200px', fixed: true, align: 'center' },
        { text: 'COMMENT', value: 'comment', sortable: false, width: '300px', fixed: true },
        { text: 'ACTIONS', value: 'actions', sortable: false, width: '300px', fixed: true }
      ],
      labTests: [
        'GLUFRU', 'PILLTEST', 'ALCOHOL', 'pH', 'TA', 'Brix', 'GLU', 'FRU',
        'Ammonia', 'AMINO_NITROGEN', 'Potassium', 'MALIC_ACID', 'FSO2',
        'TSO2', 'VA', 'BC', 'JUICE PANEL - BASIC', 'JUICE PANEL - FULL',
        'BUFFER_TITRATION', 'BUFFER_CAPACITY', 'tartaric', 'ALPHA_AMINO_COMPOUNDS',
        'Glu/Fru', 'L-Malic', 'Buffer Capacity', 'YAN', 'Ethanol', 'LACTO', 'PEDIO',
        'ACETO', 'BRETT', 'ZYGO', 'JPBRIX', 'JPGLUFRU', 'JPPH', 'JPTA', 'JPTARTARIC',
        'JPMALIC', 'JPPOT', 'JPALPHA', 'JPAMMONIA', 'JPYEAST', 'JPBUFFER', '4EP', '4EG'
      ]
    }
  },
  created () {
    if (this.wo.LabTests && this.wo.LabTests.length > 0) {
      this.labs = JSON.parse(JSON.stringify(this.wo.LabTests[0].LabResults))
    } else {
      this.labs = []
    }
    this.$emit('labsUpdated', this.labs)
  },
  methods: {
    deleteItem (index) {
      var lab = this.labs[index]
      if (lab.id) {
        this.deletedLabs.push(lab)
      }
      this.labs.splice(index, 1)
      this.$emit('labsUpdated', this.labs)
      this.$emit('deletedLabsUpdated', this.deletedLabs)
    },
    addLabTestTapped () {
      var newLab = {}
      newLab.labTest = ''
      newLab.value1 = 0
      newLab.units1 = ''
      newLab.value2 = 0
      newLab.units2 = ''
      newLab.comment = ''
      this.labs.push(newLab)
      this.$emit('labsUpdated', this.labs)
      //      this.dialog = true
    },
    // save () {
    //   if (this.editedIndex === -1) {
    //     this.labs.push(JSON.parse(JSON.stringify(this.editedItem)))
    //   } else {
    //     this.labs[this.editedIndex].labTest = this.editedItem.labTest
    //     this.labs[this.editedIndex].value1 = parseFloat(this.editedItem.value1)
    //     this.labs[this.editedIndex].units1 = this.editedItem.units1
    //     this.labs[this.editedIndex].value2 = parseFloat(this.editedItem.value2)
    //     this.labs[this.editedIndex].units2 = this.editedItem.units2
    //     this.labs[this.editedIndex].comment = this.editedItem.comment
    //   }
    //   this.dialog = false
    //   this.$emit('labsUpdated', this.labs)
    // },
    updateLabTest (index, value) {
      console.log(JSON.stringify(index, null, 2))
      console.log(JSON.stringify(value, null, 2))
      //    this.$emit('labsUpdated', this.labs)
    },
    editItem (item) {
      this.editedIndex = this.labs.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
    }
  }
}
</script>

<style scoped>
input {
  box-sizing: border-box;
  border-style:solid;
  width:100%;
  padding:4px;
  font-size: 14px;
  font-weight: bold;
}
td {
  border: 2px solid gray;
}
.largeSelect {
    width: 300px
  }
</style>
